import React from 'react';
import { Heart } from 'lucide-react';

interface HeroAnniversarySectionProps {
  couple: any;
  language: 'en' | 'mr';
}

export const HeroAnniversarySection: React.FC<HeroAnniversarySectionProps> = ({ couple, language }) => {
  return (
    <section className="relative py-24 px-4 overflow-hidden">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-block mb-4 animate-float">
            <Heart className="w-16 h-16 text-rose-500" fill="currentColor" />
          </div>
          <h1 className="text-5xl md:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-amber-300 via-rose-400 to-amber-300 mb-4 animate-fade-in">
            {language === 'mr' ? 'प्रेमाचा उत्सव' : 'Celebrating Love'}
          </h1>
          <h2 className="text-3xl md:text-4xl font-bold text-amber-200 mb-2 animate-fade-in" style={{ animationDelay: '0.2s' }}>
            {language === 'mr' ? `${couple.partner1Mr} & ${couple.partner2Mr}` : `${couple.partner1} & ${couple.partner2}`}
          </h2>
          <p className="text-xl text-rose-300 mb-4 animate-fade-in" style={{ animationDelay: '0.4s' }}>
            {language === 'mr' ? `${couple.yearsTogather} वर्षे एकत्र` : `${couple.yearsTogather} Years Together`}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
          <div className="flex justify-center">
            <div className="w-40 h-40 rounded-full border-4 border-amber-400 overflow-hidden shadow-2xl shadow-rose-500/50 transform hover:scale-105 transition-transform">
              <img src={couple.photo1} alt={couple.partner1} className="w-full h-full object-cover" />
            </div>
          </div>

          <div className="flex justify-center">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-rose-500 to-amber-500 rounded-full blur-xl opacity-50 animate-pulse"></div>
              <Heart className="w-20 h-20 text-rose-400 relative z-10" fill="currentColor" />
            </div>
          </div>

          <div className="flex justify-center">
            <div className="w-40 h-40 rounded-full border-4 border-rose-400 overflow-hidden shadow-2xl shadow-amber-500/50 transform hover:scale-105 transition-transform">
              <img src={couple.photo2} alt={couple.partner2} className="w-full h-full object-cover" />
            </div>
          </div>
        </div>

        <div className="mt-16">
          <div className="max-w-2xl mx-auto bg-white/10 backdrop-blur-md rounded-2xl border-2 border-amber-400/30 p-8 shadow-2xl">
            <img src={couple.couplePhoto} alt="couple" className="w-full h-64 object-cover rounded-xl mb-6" />
            <p className="text-center text-lg text-amber-100 font-serif italic">
              {language === 'mr' ? 'सुंदर क्षणांचा साजरा करण्यासाठी आमच्याबरोबर सामील व्हा' : 'Join us to celebrate beautiful moments and the love that has brought us here.'}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
